import type { OrganizationProfile } from '@chukua/common';
import { api } from '../lib/api';

export function getOrganization(): Promise<OrganizationProfile> {
  return api<OrganizationProfile>('/organization');
}
